<template>
  <search-layout>
    <template v-slot:contents>
      <field-input title="기간" cols="2">
        <date-input
          :start-date="startDate"
          :end-date="endDate"
          @updateDate="updateDate"
        />
      </field-input>
      <field-input title="팀" cols="2">
        <v-select
          v-model="team"
          :items="teamList"
          placeholder="팀을 선택해주세요"
          item-text="text"
          item-value="value"
          outlined hide-details dense
          background-color="white"
        />
      </field-input>
      <field-input title="상품" cols="2">
        <v-select
            v-model="gubun"
            :items="gubunList"
            placeholder="상품을 선택해주세요"
            item-text="text"
            item-value="value"
            outlined hide-details dense
            background-color="white"
        />
      </field-input>
    </template>
    <template v-slot:button>
      <search-btn @click="search" />
    </template>
  </search-layout>
</template>
<script>
import SearchLayout from "@/common/layout/SearchLayout.vue";
import SearchBtn from "@/common/components/SearchBtn.vue";
import DateInput from "@/common/components/input/DateInput.vue";
import DateMixin from "@/mixin/DateMixin";
import FieldInput from "@/common/components/input/FieldInput.vue";
import func from "@/util/func";
import _ from "lodash";
import {mapGetters} from "vuex";

export default {
  name: "LoanPerformanceTeamSearchBar",
  components: {FieldInput, DateInput, SearchBtn, SearchLayout},
  mixins: [DateMixin],
  data() {
    return {
      startDate: "",
      endDate: "",
      team: "",
      teamList: [],
      gubun: "",
      gubunList: [
        { text: "전체", value: "" },
        { text: "일반대출", value: "1" },
        { text: "집단대출", value: "6" }
      ]
    }
  },
  computed: {
    ...mapGetters("login", {
      memberRole: "memberRole",
      userData: "userData"
    }),
    isManager() {
      return this.memberRole === "MANAGER";
    }
  },
  beforeMount() {
    const {fromDate, toDate} = this.getNowMonthAllDate();
    this.startDate = fromDate;
    this.endDate = toDate;
  },
  mounted() {
    this.getOrgList();
  },
  methods: {
    search() {
      const params = {
        stDt: this.startDate.replaceAll("-", ""),
        edDt: this.endDate.replaceAll("-", ""),
        team: this.team,
        gubun: this.gubun
      };
      if (_.isEmpty(params["team"])) {
        this.showAlert({message: "팀을 선택해주세요"});
        return false;
      }
      this.$emit("search", params);
    },
    updateDate(value) {
      this.startDate = value[0];
      this.endDate = value[1];
    },
    async getOrgList() {
      const orgList = await func.getOrgList("", "Y", "N", "");
      this.teamList = this.findTypeItem(orgList, "ORG");
      if (this.isManager) {
        this.teamList = this.teamList.filter(team => team.value === this.userData.orgNm);
        this.team = this.teamList[0].value;
      }
    },
    findTypeItem(list, type) {
      let resultList = [];
      for (const item of list) {
        if (item.id !== "1000" && item.type === type) {
          resultList.push({text: item.name, value: item.name});
        }
        if (item.children && item.children.length) {
          const found = this.findTypeItem(item.children, type);
          if (found) {
            resultList = resultList.concat(found);
          }
        }
      }
      return resultList;
    },
    updateData(value) {
      this.team = value.name;
    }
  }
}
</script>